<template>
	<div>
		<div class="quota-summary">
			<div class="TopSearch" style="margin-top:16px;height:65px;">
				<FromComm :FromArr="FromArrS"></FromComm>
			</div>
			<div class="Table">
				<div class="table-title">
					内部指标汇总表
				</div>
				<!--自定义表格-->
				<div class="custom-table">
					<div class="table-key">
						<div class="title-item" v-for="(item,index) in titleList" :key="index">
							<el-dropdown v-if="index&&item.title" trigger="click" @command="handComm($event,index)">
								<span class="el-dropdown-link" @click="handLoadData(item,index)">
									{{item.title}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu style="max-height: 300px;overflow-y: auto;" slot="dropdown">
									<el-dropdown-item v-for="(item1,index1) in item.options" :key="index1"
										:disabled="item1.disabled" :command="index1">
										{{item1.key}}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
					<div class="table-value">
						<div class="value-item" v-for="(item,index) in titleList" :key="index">
							<template v-if="!index">
								{{item.val}}
							</template>
							<span class="item-val" v-else>
								{{item.val}}
							</span>
						</div>
					</div>
					<div class="table-value1">
						<div class="value-item" v-for="(item,index) in titleList" :key="index">
							<template v-if="!index">
								{{item.val1}}
							</template>
							<span class="item-val" v-else>
								{{item.val1}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="quota-summary">
			<div class="BottomTable">
				<!--  v-if="qx.update" -->
				<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px"
					@btnclick="update" :src="require('@/assets/icon/icon-update.png')" :useAutoOptional="false"
					:optional="tableCurr == null">
				</Commonbtn>
				<!--  v-if="qx.del" -->
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportFile"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<div class="TopSearch">
				<FromComm :FromArr="FromArr"></FromComm>
				<div class="btngroup">
					<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset">
					</CommonBtngroup>
				</div>
			</div>
			<div class="Table">
				<div class="table-title">
					内部指标明细表
				</div>
				<Commontable ref="refTableCenter" @onRowClick="onRowClick" width="960px" colnum=7 :tableData="tableData"
					:headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
			<DialogFrom width="1060px" :title="tableCurr?'修改':'新增'" :OKASCAN="true" :dialogVisible="dialogShow"
				@cancel="cancelEditor" @dialogOK="dialogOKEditor">
				<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod" @selectChange="handChange"></FromComm>
			</DialogFrom>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../../components/common-btn.vue'
	import DialogFrom from '../../../../../../../components/dialog-from.vue'
	import Pagination from '../../../../../../../components/pagination.vue'
	import CommonbtnUpLoad from './../../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../../components/common-table.vue'
	import Dialog from '../../../../../../../components/dialog.vue'
	import FromArr from '../FormData/FromArrIms'
	import FromArrS from '../FormData/FromArrImsS'
	import FromArrEditorS from '../FormData/FromArrEditorImsS'
	import headerData from '../TableData/headerImsData'
	import utils from "../../../../../../../common/utils";
	import {
		InventoryClassList,
		CusRelationUserInfoList,
		GetProvince,
		GetHelperCountryMan,
		GetHelperAreaMan,
		GetHelperRegionMan,
		GetHelperSalesMan,
	} from '@/api/home'
	import {
		HelperLEVEL3
	} from '@/api/channel'
	import {
		GetQuotaInnerSummary,
		GetQuotaInnerList,
		GetQuotaInnerInfo,
		ExportQuotaInnerInfo,
		EditQuotaInner
	} from '@/api/newsapi'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Dialog,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				FromArrS: [],
				FromArrEditor: [],
				tableCurr: null,
				tableData: [],
				headerData: [],
				tableDatadrjg: [],
				summaryData: [],
				query2: {},
				titleList: [{
					val: '汇总项',
					val1: '金额BP'
				}, {
					title: '产品线',
					key: 'invClass',
					val: '',
					val1: '',
					options: []
				}, {
					title: 'Level3',
					key: 'leveL3',
					val: '',
					val1: '',
					options: []
				}, {
					title: '销售-全国',
					key: 'countryMan',
					val: '',
					val1: '',
					options: []
				}, {
					title: '销售-大区',
					key: 'areaMan',
					val: '',
					val1: '',
					options: []
				}, {
					title: '销售-小区',
					key: 'regionMan',
					val: '',
					val1: '',
					options: []
				}]
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrS = JSON.parse(JSON.stringify(FromArrS))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditorS))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.inventoryClassList();
			this.HelperLEVEL3();
			this.getData();
		},
		methods: {
			handChange(e) {
				if (e === 1) {
					this.FromArrEditor[2].disabled = false;
					this.FromArrEditor[3].disabled = false;
					this.HelperLEVEL3(false);
				}
			},
			async getData() {
				this.query.year = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue;
				this.query.leveL3 = this.FromArr[2].modelvalue;
				this.query.areaManName = this.FromArr[3].modelvalue;
				let {
					code,
					data
				} = await GetQuotaInnerList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					this.FromArrS[0].options = []
					this.FromArr[1].options = []
					this.titleList[1].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
						this.FromArrEditor[1].options.push(obj)
						this.titleList[1].options.push({
							key: item.InvClassName,
							val: item.InvClass,
						})
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[0].options.push(obj)
						this.FromArrS[0].options.push(obj)
						this.FromArrEditor[0].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			// 产品分类L3
			async HelperLEVEL3(isNeed = true) {
				let params = {};
				if (!isNeed) {
					params.InvClass = this.FromArrEditor[1].modelvalue;
				}
				let {
					code,
					data,
					message
				} = await HelperLEVEL3(params);
				if (code == 0) {
					if (isNeed) {
						this.FromArr[2].options = []
					}
					this.FromArrEditor[2].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						if (isNeed) {
							this.FromArr[2].options.push(obj)
						}
						this.FromArrEditor[2].options.push(obj)
					})
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			onRowClick(val) {
				this.tableCurr = val.ID;
			},
			// 导出
			async exportFile() {
				if (this.FromArr[0].modelvalue) {
					this.query.year = this.FromArr[0].modelvalue;
				}
				if (this.FromArr[1].modelvalue) {
					this.query.invClass = this.FromArr[1].modelvalue;
				}
				if (this.FromArr[2].modelvalue) {
					this.query.leveL3 = this.FromArr[2].modelvalue;
				}
				if (this.FromArr[3].modelvalue) {
					this.query.areaManName = this.FromArr[3].modelvalue;
				}
				let resexprot = await ExportQuotaInnerInfo(this.query);
				if (resexprot) {
					utils.downloadFile(resexprot, "指标汇总", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			//编辑
			async update() {
				if (!this.tableCurr) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data
				} = await GetQuotaInnerInfo({
					id: this.tableCurr
				})
				if (code == 0) {
					this.FromArrEditor = this.FromArrEditor.map((item, index) => {
						if (!item.key.includes('Quota')) {
							item.modelvalue = data.data[item.key];
						}
						item.modelValue = data.data[item.key];
						if (index === 3) {
							item.options = [{
								label: data.data.AreaManName,
								value: data.data.AreaMan
							}]
						}
						return item;
					})
					this.dialogShow = true;
					this.$forceUpdate();
				}
				loading.close();
			},
			//模糊查询
			async remoteMethod(val) {
				let {
					code,
					data
				} = await CusRelationUserInfoList({
					RID: 4,
					PersonGrade: 3,
					TrueName: val.qurey,
					InvClass: this.FromArrEditor[1].modelvalue,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.data.forEach((item, index) => {
						let obj = {
							label: item.TrueName,
							value: item.UserName
						}
						this.FromArrEditor[3].options.push(obj)
					})
				}
			},
			//取消编辑
			cancelEditor() {
				this.FromArrEditor = this.FromArrEditor.map(item => {
					item.modelValue = undefined;
					item.modelvalue = '';
					return item;
				})
				this.tableCurr = null;
				this.dialogShow = false;
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				let params = {};
				this.FromArrEditor.map(item => {
					params[item.key] = item.modelvalue || item.modelValue;
				})
				params.id = this.tableCurr;
				let {
					code,
					data,
					message
				} = await EditQuotaInner(params)
				if (code == 0) {
					this.tableCurr = null;
					this.$message.success('已修改');
					this.cancelEditor();
					this.handSearch();
				} else {
					this.$message.error(message);
				}
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			//顶部表格查询
			getSummary(query, callback) {
				query.year = this.FromArrS[0].modelvalue;
				query.month = this.FromArrS[1].modelvalue;
				GetQuotaInnerSummary(query).then(res => {
					let {
						code,
						data
					} = res
					if (code == 0) {
						callback(data);
					}
				})
			},
			handComm(e, i) {
				let params = {};
				this.query2[this.titleList[i].key] = this.titleList[i].options[e].val;
				this.titleList[i].val = this.titleList[i].options[e].key;
				if (i === 1) {
					params.invClass = this.query2.invClass;
				}
				if (i === 2) {
					params.leveL3 = this.query2.leveL3;
				}
				if (i === 3) {
					params.salesMan = this.query2.countryMan;
				}
				if (i === 4) {
					params.salesMan = this.query2.areaMan;
				}
				if (i === 5) {
					params.salesMan = this.query2.regionMan;
				}
				this.getSummary(params, res => {
					this.titleList[i].val1 = res.MoneyQuotaString;
				})
			},
			handLoadData(e, i) {
				if (!this.FromArrS[0].modelvalue || !this.FromArrS[1].modelvalue) {
					this.$message.error('请选择年份和月份');
					return;
				}
				let params = {};
				switch (i) {
					case 2:
						params.invClass = this.query2.invClass;
						HelperLEVEL3(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.key,
										val: item.value,
									})
								})
							}
						})
						break;
					case 3:
						params.invClass = this.query2.invClass;
						GetHelperCountryMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
					case 4:
						params.invClass = this.query2.invClass;
						params.ParentUserName = this.query2.countryMan
						GetHelperAreaMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
					case 5:
						params.invClass = this.query2.invClass;
						params.ParentUserName = this.query2.areaMan
						GetHelperRegionMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.quota-summary {
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

	}

	.TopSearch {
		height: 140px;
		margin: 0px 0px 8px;
		border-top: 1px solid #EEEEEE;


		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 20px;
		}
	}

	.BottomTable {
		margin: 14px 0px 0px;
	}

	.Table {
		.table-title {
			font-size: 14px;
			font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
			font-weight: 500;
			color: #333333;
			padding: 0px 0px 16px 16px;
		}

		.custom-table {
			cursor: pointer;
			user-select: none;
			padding: 16px;
			box-sizing: border-box;

			.table-key {
				display: flex;

				.title-item {
					flex: 1;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					background: #F9F9F9;
					border-bottom: 0px;
					border-right: 0px;

					.el-dropdown-link {
						font-size: 14px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 500;
						color: #333333;
					}
				}

				.title-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}

			.table-value {
				display: flex;

				.value-item {
					flex: 1;
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 500;
					color: #333333;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					border-right: 0px;
					border-bottom: 0px;

					.item-val {
						font-size: 10px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 400;
						color: #666666;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 94px;
						display: inline-block;
					}
				}

				.value-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}

			.table-value1 {
				display: flex;

				.value-item {
					flex: 1;
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 500;
					color: #333333;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					border-right: 0px;

					.item-val {
						font-size: 14px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 400;
						color: #333333;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 94px;
						display: inline-block;
					}
				}

				.value-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}
		}
	}
</style>
